/**
 * Created by fers on 05.02.16.
 */
import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import types from '../../common/model-api/types';
import Relay from 'react-relay';
import {FormattedMessage, injectIntl, defineMessages, IntlShape} from 'react-intl';
import ChannelHeader from './ChannelHeader.react';
import EditorSaver from '../fw/EditorSaver';
import ScenarioBoxAsWizard from '../scenarios/ScenarioBoxAsWizard.react';
import ScenarioIcon from '../scenarios/ScenarioIcon.react';
import "../scenarios/Scenario.scss";
import "./channel.scss";

import {wrapNotFound} from '../app/NotFoundHandler.react';
import * as Tool from '../fw/Tool';
import ScenarioWizard from '../scenarios/ScenarioWizard.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import {getUrlForChannelCreate} from './getUrlForChannelCreate';
import * as Permission from './../../common/util/Permission';
import * as BrowserPermission from '../BrowserPermission';
import {AUTH_TYPE_PER_USER} from "../../common/model-api/ChannelDefType";
import config from '../../common/config';
import ScenarioPrerequisite from '../scenarios/ScenarioPrerequisite.react';
import AgentLink from '../fw/AgentLink.react';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'channelAddStep1.addTitle', 'defaultMessage': 'Adding My App'}
});

export function createChannelFromChannelDef(channelDef, organisation, activate : boolean = false, options) {
    let fatQuery = Relay.QL `fragment on CreateChannelPayload @relay(pattern: true) {
                                    edge {
                                        node {
                                            id,
                                            realId,
                                            activated,
                                            options,
                                            channelDef {
                                                id,
                                                realId,
                                                metadata,
                                            }
                                        }
                                    },
                                    organisation {
                                        channels(first: 100, deleted: false) {
                                            edges {
                                                node {
                                                    id
                                                }
                                            }
                                        }
                                    }
                                }`;

    let mutation = Relay.QL `mutation { createChannel }`;

    let save = types['channels'].defaultValues(organisation);

    save['channelDef_id'] = channelDef.realId;
    if (activate) {
        save['activated'] = true;
    }
    if (options && Object.keys(options)) {
        save['options'] = options;
    }

    let saver = new EditorSaver(types['channels'], mutation, fatQuery, null, EditorSaver.CREATE);
    return saver.save(save).then((result) => {
        return Promise.resolve(result.createChannel.edge.node);
    });
}

interface ChannelAddStep1Props {
    cancel?: (...args: unknown[]) => unknown | boolean;
    createCallback?: (...args: unknown[]) => unknown;
    intl: IntlShape;
    relay: object;
    user: User;
    wrapper?: boolean;
}

class ChannelAddStep1 extends React.Component<ChannelAddStep1Props> {

    static propTypes = {
		cancel: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
		createCallback: PropTypes.func,
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
		wrapper: PropTypes.bool
    };

	static defaultProps = {
		wrapper: false
	};

    typeName = 'channels';

    static contextTypes = {
        router: PropTypes.object
    };

	constructor(props, context) {
		super(props);

		if (props.user.channelDefs) {
			ScenarioPrerequisite.redirectToScenarioIfNeeded(context.router, props.user.channelDefs.edges[0].node.realId);
		}

        this.componentWillReceiveProps(props);
	}

    componentWillReceiveProps(props) {
        if (this.variableSet) {
            return;
        }

        if (props.user.channelDefs && props.user.channelDefs.edges && props.user.channelDefs.edges.length > 0) {
            let channelDef = props.user.channelDefs.edges[0].node;

            this.variableSet = true;
            this.props.relay.setVariables({
                channelDefId: channelDef.realId,
            });
        }
    }

    _create = () => {
        let {channelDef} = this.props.user;

        if (!channelDef) {
            channelDef = this.props.user.channelDefs.edges[0].node;
        }

        if (!this.props.user.organisation) {
            return;
        }

        let promise;

        /* we already have one unactivated channel */
        if (this.props.user.organisation.unactivatedChannels && this.props.user.organisation.unactivatedChannels.edges.length > 0) {
            let channel = this.props.user.organisation.unactivatedChannels.edges[0].node;
            promise = Promise.resolve(channel);
        } else {
            promise = createChannelFromChannelDef(channelDef, this.props.user.organisation);
        }

        return promise.then((channel) => {
			if (this.props.createCallback) {
				channel.channelDef = channelDef;
				this.props.createCallback(channel);
			}
			else {
				let path = getUrlForChannelCreate(this.props.user.organisation, channel, channelDef, this.props.user.scenario) + (document.location.search ? document.location.search : "");
                this.context.router.push(path);
			}
        });
    };

    showAddButton(channelDef) {


        if (channelDef.hideAddButton) {
            return null;
        }
        if (channelDef.canBeAddedOnce) {
            if (this.props.user?.organisation?.allChannels?.edges?.length > 0) {
                const hasNoDeletedChannel = this.props.user.organisation?.allChannels?.edges?.some(edge => !edge.node.deleted);
                if (hasNoDeletedChannel) {
                    return <button className="btn btn-default" disabled><FormattedMessage defaultMessage="{app} be added only once" id="channel.cantBeAddedTwice" values={{app: channelDef.name}} /></button>;
                }
            }
        }

        if (!BrowserPermission.hasOrganisationPermission(Permission.PERM_EDIT_CHANNEL, this.props.user.organisation.realId)) {
            return <button className="btn btn-default" disabled><FormattedMessage defaultMessage="You don't have enough permission to connect application." id="channel.permission.requires" /></button>;
        }

        if (channelDef && !channelDef.showContactUs || BrowserPermission.hasPermission(Permission.PERM_EDIT_CHANNEL_DEF)) {
            return this._create().then(() => {
                document.location.reload();
            });
        }

        if (channelDef.addType !== 'none') {
            return (<div>
                    {this.props.user.organisation && this.props.user.organisation.users && this.props.user.organisation.users.edges.length > 1
                        ? <p className="connectionNote"><strong><FormattedMessage defaultMessage="Connection note:" id="channel.connectionNote" /></strong>&nbsp;
                            {channelDef.authType === AUTH_TYPE_PER_USER
                                ? <FormattedMessage defaultMessage="each user will have to authorize this application separately. The screen settings will be shared." id="channel.warningExplanation.eachUser" values={{app: channelDef.name}}/>
                                : <FormattedMessage defaultMessage="by connecting {app} you will allow access for all your users." id="channel.warningExplanation.allUsers" values={{app: channelDef.name}}/>
                            }
                        </p>
                        : null
                    }
                    {channelDef.showContactUs && !BrowserPermission.hasPermission(Permission.PERM_EDIT_CHANNEL_DEF) ?
                        <a className="btn btn-primary" href={"mailto:" + config.SALES_EMAIL + '?subject=' + encodeURIComponent(channelDef.name)}><span className="fa fa-envelope"/>{" "}
                               <FormattedMessage defaultMessage="Contact Us" id="channelDef.contactUs" />
                        </a>
                        :
                        <div>
                            {/* <button className="btn btn-primary" onClick={this._create}><FormattedMessage
                                defaultMessage="Start using " id="channel.startUsingFor"/>{" "}{channelDef.name}
                            </button> */}

                            {this.props.cancel ? <button className="btn btn-link" onClick={() => {this.props.cancel();}}><FormattedMessage defaultMessage="Cancel" id="common.cancel" /></button> : null}
                        </div>
                    }
            </div>);
        }

        return null;
    }

    render() {
		if (this.props.wrapper) {
			this._create();
			return null;
		}

        let {channelDef} = this.props.user;

        if (!channelDef) {
            channelDef = this.props.user.channelDefs.edges[0].node;
        }

        let type = types['channelDefs'];

        let longDescription = Tool.getDataForColumn('longDescription', type.fields(), channelDef);

        if (longDescription) {
            longDescription = Tool.tranformDataForView('channelDefs', type.fields('longDescription'), this.props.intl.formatMessage, longDescription, false, 0);
        } else {
            longDescription = channelDef.description;
        }

        let connectRequirement = null;
        if (channelDef.connectRequirement) {
            connectRequirement = Tool.getFormatted(type, 'connectRequirement', this.props.intl.formatMessage, channelDef);
        }
        if (channelDef.requiresAgent) {
            connectRequirement = (<span><FormattedMessage defaultMessage="Requires installation of {agentLink}." id="channelDef.requiresAgentUrl" values={{
                productName: config.PRODUCT_NAME,
                agentLink: <AgentLink />
            }}/> {connectRequirement}</span>);
        }

        let requiredPayPlan = channelDef.requiredPayPlan;

        if (requiredPayPlan) {
            if (requiredPayPlan === "-") {
                requiredPayPlan = null;
            } else {
                requiredPayPlan = Tool.getFormatted(type, 'requiredPayPlan', this.props.intl.formatMessage, channelDef);
            }
        }

		let metadata = types['channelDefs'];
		let tagsTag = null;
        let columnMapping = Tool.getMappingForColumn('state', metadata.fields());
        let tags = Tool.getDataForColumn('state', metadata.fields(), channelDef);
        if (tags) {
            if (!('hide' in columnMapping['values'][tags]) && !columnMapping['values'][tags].hide) {
                let style = {};
                if (columnMapping['values'][tags].color) {
                    style['backgroundColor'] = columnMapping['values'][tags].color;
                }
                tagsTag = (
                    <span className="badge" style={style}>{Tool.tranformDataForView(metadata.entity(), columnMapping, this.props.intl.formatMessage, tags, true)}</span>);
            }
        }
		let content = (<div>
			<ChannelHeader data={channelDef} isChannelDef organisation={this.props.user.organisation} tag={tagsTag} title={channelDef.name} />

			<p>{longDescription}</p>

			{connectRequirement ? <p className="connect-requirement"><strong>{Tool.getLabel(type, 'connectRequirement', this.props.intl.formatMessage)}:</strong> {connectRequirement}</p> : null}
			{requiredPayPlan || channelDef.extraPayment ?
				<span className="payment-info">{requiredPayPlan
					? (channelDef.extraPayment
						? <FormattedMessage defaultMessage="Requires {planName} and extra payment for some service." id="channelDef.payPlan.requires-and-payment" values={{planName: requiredPayPlan}}/>
						: <FormattedMessage defaultMessage="Requires {planName}." id="channelDef.payPlan.requires" values={{planName: requiredPayPlan}}/>
					)
					: <FormattedMessage defaultMessage="Requires extra payment for some service." id="channelDef.payPlan.requires-extra-payment" values={{planName: requiredPayPlan}}/>
				}<br/></span> : null
			}


            {this.showAddButton(channelDef)}
		</div>);

        return (
            <AppPanel breadcrumbParams={[
                {type: types['channelDefs'], data: channelDef},
                {type: types['scenarios'], data: this.props.user.scenario},
                {type: types['organisations'], data: this.props.user.organisation}]
            } title={this.props.intl.formatMessage(messages.title)}>
				<ScenarioWizard data={this.props.user} step={1} type={type}>
					{content}
				</ScenarioWizard>
            </AppPanel>
        );
    }
}


export default Relay.createContainer(wrapNotFound(injectIntl(ChannelAddStep1), (props) => {
    return (props.user.channelDefs && props.user.channelDefs.edges.length > 0) || props.user.channelDef;
}), {
    initialVariables: {
        channelDefId: '',
        channelDefUrlFragment: '',
        channelDefIdSelected: false,
        channelDefUrlFragmentSelected: false,
        organisationId: '',
        scenarioId: '',
        scenarioSelected: false,
        organisationSelected: false,
    },
    prepareVariables (variables) {
        if (!variables.organisationId) {
            variables.organisationId = getLastOrganisationId();
        }
        variables['scenarioSelected'] = variables['scenarioId'] ? true : false;
        variables['organisationSelected'] = variables['organisationId'] ? true : false;
        variables['channelDefIdSelected'] = variables['channelDefId'] ? true : false;
        variables['channelDefUrlFragmentSelected'] = variables['channelDefUrlFragment'] ? true : false;
        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                firstname,
                surname,
                email,
                organisation(id: $organisationId) @include(if: $organisationSelected) {
                    id,
                    realId,
                    name,
                    users(first: 2) {
                        edges {
                            node {
                                id,
                                realId
                            }
                        }
                    },
                    ${ScenarioBoxAsWizard.getFragment('organisation')},
                    unactivatedChannels(first: 10, channelDefUrlFragment: $channelDefUrlFragment, channelDefId: $channelDefId) {
                        edges {
                            node {
                                id,
                                realId,
                                channelDef_id,
                                activated,
                                enabled,
                            }
                        }
                    },
                    channels(channelDef: $channelDefId, first: 1) @include(if: $channelDefIdSelected) {
                        edges {
                            node {
                                id,
                                realId,
                                channelDef_id,
                                activated,
                                enabled,
                                deleted
                            }
                        }
                    },
                    allChannels: channels(channelDef: $channelDefId, first: 100) @include(if: $channelDefIdSelected) {
                        edges {
                            node {
                                id,
                                realId,
                                channelDef_id,
                                activated,
                                enabled,
                                deleted
                            }
                        }
                    }
                },
                organisations(first: 20) {
                    edges {
                        node {
                            id,
                            realId,
                            name
                        }
                    }
                },
                scenario(id: $scenarioId) @include(if: $scenarioSelected) {
                    id,
                    realId,
                    ${ScenarioBoxAsWizard.getFragment('scenario')}
                    ${ScenarioIcon.getFragment('scenario')}
                },
                channelDef: publicChannelDef(id: $channelDefId) @include(if: $channelDefIdSelected) {
                    id,
                    realId,
                    metadata,
                    description,
                    addType,
                    authType,
                    showContactUs,
                    hideAddButton,
                    longDescription,
                    connectRequirement,
                    canBeAddedOnce,
                    requiresAgent,
                    canUseAgent,
                    name,
                    icon
                },
                channelDefs: publicChannelDefs(first: 1, urlFragment: $channelDefUrlFragment) @include(if: $channelDefUrlFragmentSelected) {
                    edges {
                        node {
                            id,
                            realId,
                            metadata,
                            description,
                            addType,
                            authType,
                            showContactUs,
                            hideAddButton,
                            longDescription,
                            connectRequirement,
                            canBeAddedOnce,
                            requiresAgent,
                            canUseAgent,
                            name,
                            icon
                        }
                    }
                }
            }
        `,
    },
});
